import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Link, Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import { REACT_URL_HEALTHQUESTIONARIES } from "../../actions/EndPoints";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import { getAllChecklisttemplate } from "../../slices/ChecklistTemplatesUSA/ChecklistTemplateSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import ChecklistIcon from "../Checklist/ChecklistIcon";
import EditIcon from "../Person/EditIcon";
import AddChecklistTemplate from "./AddChecklistTemplate";
import ChecklistTemplateUSAView from "./ChecklistTemplateUSAView";
import FilterChecklistTemplate from "./FilterChecklistTemplate";

export default function ChecklistTemplateUSA(props) {
  const [clear, setClear] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const { setDiaLogBoxBlur } = useContext(ThemeContext);

  const [selectedObject, setSelectedObject] = useState({
    id: "",
    name: "",
    companyId: "",
    description: "",
  });

  const [paging, setPaging] = useState({
    page: 1,
    rowsPerPage: 50,
  });

  const [filter, setFilter] = React.useState({
    id: "",
    name: "",
  });
  const defaultFilter = {
    id: "",
    name: "",
  };

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      page: newPage,
      rowsPerPage: size,
    });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging, clear]);

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const resetFilter = () => {
    setClear(false);
    setPaging({ ...paging, page: 1 });
    setFilter(defaultFilter);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const loadData = (filter, paging) => {
    dispatch(getAllChecklisttemplate(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setPage(data.data.curPage);
          setTotalPages(data.data.totalPages);
          setRows(data.data.visitors);
        } else {
          setRows([]);
        }
      })
      .catch((er) => { });
  };

  const handleFilter = (data) => {
    setClear(true);
    setPaging({ ...paging, page: 1 });
    setFilter({
      name: data.name,
    });
  };

  const handleEditVisit = (params) => {
    setOpenEditDialog(!openEditDialog);
    setSelectedObject(params);
    setDiaLogBoxBlur(true);
  };

  const handleChecklistItem = (params) => {
    history.push({
      pathname: REACT_URL_HEALTHQUESTIONARIES,
      state: { data: params.row },
    });
  };

  const columns = React.useMemo(() => [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },
    {
      field: "name",
      headerName: t("COMMON014"),
      flex: 1,
      width: 110,
      valueGetter: (params) => params.row.name,
    },

    {
      field: "description",
      headerName: t("ATYPE009"),
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params.row.description,
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 205,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <ChecklistTemplateUSAView
          title="Checklist Template Details"
          rowData={params.row}
        />,
        <Box onClick={() => handleEditVisit(params.row)}>
          <EditIcon />
        </Box>,

        <GridActionsCellItem
          icon={<ChecklistIcon />}
          label={t("COMMON146")}
          onClick={() => handleChecklistItem(params)}
        />,
      ],
    },
  ]);

  return (
    <>
      <HeaderToolbar
        title={t("CHECKLIST001")}
        tooltipTitle={t("CHECKLIST004")}
      />
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        style={{
          gap: "8px",
          padding: "10px 0px 10px 10px",
        }}
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("CHECKLIST001")}>
          <Box item className={"addIcon"} onClick={handleOpen}>
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box item className="refreshIcon">
            <RefreshIcon onClick={() => loadData(filter, paging)} />
          </Box>
        </Tooltip>

        <Box item>
          <FilterChecklistTemplate
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleFilter(data)}
          />
        </Box>
      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {open && (
        <AddChecklistTemplate
          selectedObject={selectedObject}
          open={open}
          handleClose={() => {
            handleClose(loadData(filter, paging));
            setDiaLogBoxBlur(false);
          }}
        />
      )}

      {openEditDialog && (
        <AddChecklistTemplate
          selectedObject={selectedObject}
          open={openEditDialog}
          handleClose={() => {
            setOpenEditDialog(false);
            loadData(filter, paging);
            setDiaLogBoxBlur(false);
            setSelectedObject({
              id: "",
              name: "",
              description: "",
            });
          }}
        />
      )}
    </>
  );
}
